import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=04ac3adc"
import script from "./faq.vue?vue&type=script&lang=ts"
export * from "./faq.vue?vue&type=script&lang=ts"
import style0 from "./faq.vue?vue&type=style&index=0&id=04ac3adc&prod&lang=scss"
import style1 from "./faq.vue?vue&type=style&index=1&id=04ac3adc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports